import { FC } from "react";
import style from "./style.module.css";
import { NO_PLANS } from "@assets/images/location/ASSETS_IMAGES";
import { cn, getCDNAssetUrl } from "@utils/utilities";

interface props {
  theme?: string;
}

const NoPlansAvailable: FC<props> = ({ theme }) => {
  return (
    <div className={style.wrapper}>
      <img src={getCDNAssetUrl(NO_PLANS)} />
      <span
        className={cn({
          [style.dark]: theme === "dark",
          [style.light]: !theme,
        })}
      >
        No plans available at this moment
      </span>
    </div>
  );
};

export default NoPlansAvailable;
